export const API_URL = '';
export const CHECKOUT_PAYMENT_URL = '';
export const CODEPUSH_DEPLOYMENT_KEY = '';
export const FACEBOOK_APP_ID = '';
export const GOOGLE_MAPS_API_KEY = '';
export const NODE_ENV = '';
export const REMOTE_CONFIG_FETCH_INTERVAL = '';
export const SENTRY_DSN = '';
export const WEB_CLIENT_ID_ANDROID = '';
export const WEB_CLIENT_ID_IOS = '';

export default {};
